import React from "react";
import Loader from "../../common/Loader";
import Pagination from "../../common/Pagination";
import PuceStatut from "./PuceStatut";
import { formaterDate } from "./effacementDonnees";
import { PAR_PAGE } from "./useEffacementDonnees";

const demandes = (nombre) => `${nombre} demande${nombre > 1 ? "s" : ""}`;

const RegistreEffacements = ({ registre, charge, demandeOuverteId, onConsulter, onChangerPage }) => {
  const nbPages = Math.ceil(registre.total / PAR_PAGE);

  return (
    <section className="effacement__carte" aria-labelledby="titre-registre">
      <header className="effacement__entete">
        <div>
          <h2 className="effacement__titre" id="titre-registre">
            Registre des effacements
          </h2>
          <p className="effacement__meta">Une ligne par demande, sans aucune donnée personnelle.</p>
        </div>
        {charge && registre.total > 0 && <span className="effacement__total">{demandes(registre.total)}</span>}
      </header>

      {!charge ? (
        <div className="effacement__chargement" aria-busy="true">
          <Loader size={32} />
          <span className="sr-only">Chargement du registre…</span>
        </div>
      ) : registre.data.length === 0 ? (
        <div className="effacement__vide">
          <i className="fa fa-clipboard-list" aria-hidden="true" />
          <p>Aucun effacement pour le moment.</p>
        </div>
      ) : (
        <div className="table-responsive">
          <table className="effacement__table">
            <thead>
              <tr>
                <th scope="col">Demandé le</th>
                <th scope="col" className="d-none d-md-table-cell">Par</th>
                <th scope="col">Statut</th>
                <th scope="col" className="d-none d-sm-table-cell">Clos le</th>
                <th scope="col">
                  <span className="sr-only">Actions</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {registre.data.map((demande) => (
                <tr
                  key={demande.id}
                  className={demande.id === demandeOuverteId ? "effacement__ligne-ouverte" : undefined}
                >
                  <td>{formaterDate(demande.demandeeLe)}</td>
                  <td className="d-none d-md-table-cell">{demande.demandeePar.nomComplet || "-"}</td>
                  <td>
                    <PuceStatut statut={demande.statut} />
                  </td>
                  <td className="d-none d-sm-table-cell">{formaterDate(demande.termineeLe)}</td>
                  <td className="text-right">
                    <button
                      className="btn btn-link btn-sm"
                      data-demande={demande.id}
                      aria-haspopup="dialog"
                      onClick={() => onConsulter(demande.id)}
                      aria-label={`Ouvrir l'effacement du ${formaterDate(demande.demandeeLe)}`}
                    >
                      <span className="d-none d-sm-inline">Ouvrir</span>
                      <i className="fa fa-chevron-right ml-sm-1" aria-hidden="true" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {charge && nbPages > 1 && (
        <div className="effacement__pagination">
          <Pagination page={registre.page} nbPages={nbPages} changePage={onChangerPage} />
        </div>
      )}
    </section>
  );
};

export default RegistreEffacements;
